import ToggleBtn from "components/button/toggle";
import { useTranslation } from "react-i18next";
import "./formHead.scss";

type IProps = {
  title: string;
  sub?: string;
  formId: string;
  btnTxt?: string;
  btnVisible?: boolean;
};

export default function UpdateFormHead({
  title,
  sub,
  formId,
  btnTxt = "btn_edit_cmm",
  btnVisible = true,
}: IProps) {
  const { t } = useTranslation();
  return (
    <div className="sub-head">
      <ul className="">
        <li className="flex items-center gap-2">
          <h3>{title}</h3>
          <sub className={sub ? "text-red-600 font-bold" : "hidden"}>{sub}</sub>
        </li>
        <li className="flex items-center gap-2">
          <div className="flex gap-1">
            <button
              type="submit"
              form={formId}
              hidden={!btnVisible}
              className="btn text-white bg-red-400"
            >
              {t(btnTxt)}
            </button>
            <ToggleBtn />
          </div>
        </li>
      </ul>
    </div>
  );
}
